import Vue from 'vue'
import { getPermission } from '@/utils/auth'
Vue.directive('auth', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el, binding) {
    // 聚焦元素
    el.focus()
  }
})